import axios from '@/api/config';

const polyvChannel = {
    getChannel(data) {
      return axios.get(`${process.env.BASE_URL}/polyvChannel/getChannel`, {params: data});
    },
    addPolyvChannel(data) {
      return axios.post(`${process.env.BASE_URL}/polyvChannel/addPolyvChannel`, data);
    },
    pageList(data) {
      return axios.post(`${process.env.BASE_URL}/polyvChannel/pageList`, data);
    },
    getPolyvChannel(data) {
      return axios.get(`${process.env.BASE_URL}/polyvChannel/getPolyvChannel`, {params: data});
    },
    updatePolyvChannel(data) {
      return axios.put(`${process.env.BASE_URL}/polyvChannel/updatePolyvChannel`, data);
    },
    getChannelIdV2(data) {
      return axios.post(`${process.env.BASE_URL}/polyv/getChannelIdV2`,  data);
    },
}

export default polyvChannel;



// WEBPACK FOOTER //
// ./src/api/polyvChannel.js